import { Hours, Location, Locations, SalaryRange, SalaryValue } from '..';

export enum ChipUSPsVariant {
  Group = 'GROUP',
  LocationSpecific = 'LOCATION_SPECIFIC'
}

export enum EducationLevel {
  First = 'FIRST',
  None = 'NONE',
  Second = 'SECOND',
  Third = 'THIRD'
}

export type BaseChipUSPs = {
  variant: ChipUSPsVariant;
  hoursRange: Hours;
  salaryValue?: SalaryValue;
  salaryRange?: SalaryRange;
  relocationPossible: boolean;
};

export type LocationSpecificChipUSPs = BaseChipUSPs & {
  variant: ChipUSPsVariant.LocationSpecific;
  location: Location;
};

export type GroupChipUSPs = BaseChipUSPs & {
  variant: ChipUSPsVariant.Group;
  locations: Locations;
};

export type ChipUSPs = LocationSpecificChipUSPs | GroupChipUSPs;
